import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type ManageHintProps = ComponentProps<"div">

function ManageHint(props: ManageHintProps) {
  const { className, ...divProps } = props
  return <div className={cn("manage-hint", className)} {...divProps} />
}

export default ManageHint
